import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import {
    commanderForm,
    EnumifySelectField,
    InputField,
    integerGreaterOrEqualToOne,
    integerGreaterOrEqualToZero,
    presence,
    TextareaField,
    validation,
} from '@mews-commander/legacy-form';
import { FieldsContainer } from '@mews-commander/ui';
import { RowFormElement } from '../style';

const constraints = {
    name: { presence },
    resourceCategoryType: { presence },
    capacity: {
        presence,
        numericality: integerGreaterOrEqualToOne,
    },
    extraCapacity: {
        numericality: integerGreaterOrEqualToZero,
    },
    shortcut: { presence },
};

const CategoryForm = () => (
    <FieldsContainer>
        <EnumifySelectField
            name="resourceCategoryType"
            label={<LocalizedText textKey={TextKey.Type} />}
            enumClass={ResourceCategoryType}
            required
            useNameAsValue
        />
        <InputField autoComplete="off" name="name" label={<LocalizedText textKey={TextKey.CategoryName} />} required />
        <InputField autoComplete="off" name="shortcut" label={<LocalizedText textKey={TextKey.ShortName} />} required />
        <TextareaField autoComplete="off" name="description" label={<LocalizedText textKey={TextKey.Description} />} />
        <RowFormElement>
            <InputField
                autoComplete="off"
                name="capacity"
                label={<LocalizedText textKey={TextKey.Capacity} />}
                required
            />
            <InputField
                autoComplete="off"
                name="extraCapacity"
                label={<LocalizedText textKey={TextKey.ExtraCapacity} />}
            />
        </RowFormElement>
    </FieldsContainer>
);

export default commanderForm({
    enableReinitialize: true,
    submitLabel: <LocalizedText textKey={TextKey.Save} />,
    validate: validation(constraints),
    submitButtonProps: { variant: 'primary' },
})(CategoryForm);
